module.exports = __webpack_public_path__ + "img/thumb-vagues.fb995f80.jpg";